import axios from 'axios';

export default function domainStatus(domain) {
  return new Promise(function (resolve, reject) {
    axios.post('/clientarea.php', {
      action: 'getDomainStatus',
      domain: domain
    }).then(function (response) {
      if (response.data && response.data.success) {
        resolve(response.data);
      } else {
        reject(response.data);
      }
    }).catch(function (error) {
      reject(error);
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/components/domain_status.js